// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"CE-z","smallCardRow":"DE-z","largeCardRow":"EE-z","productSearchRow":"FE-z","curatedRow":"GE-z"};